export const PRIMARY_BRAND_COLOR = '#00c590';
